<main class="nav">
  <div class="nav--container">
    <div class="nav--menu">
      <div class="nav--menu__imgContainer">
        <img *ngIf="landing2 && user?.groupType !== collective.EXTERNVO" class="img"
          src="../../../assets/logos/logo-seat-sa.svg" alt="{{ 'altLogo' | i18next }}" (click)="changeMenu('landing2')"
          [routerLink]="['/landing-leasing']" />
        <img *ngIf="!landing2" class="img" src="../../../assets/logos/logo-seat-sa.svg" alt="{{ 'altLogo' | i18next }}"
          (click)="changeMenu('home')" [routerLink]="['/landing']" />
        <img *ngIf="user?.groupType === collective.EXTERNVO" class="img" src="../../../assets/logos/logo-seat-sa.svg"
          alt="{{ 'altLogo' | i18next }}" (click)="changeMenu('vo')" [routerLink]="['/vo']" />
      </div>
      <ul class="nav--menu__list">
        <li *ngIf="landing2 && user?.groupType !== collective.EXTERNVO">
          <button class="nav--menu__list--item" [style]="
              selectedItem === 'landing2'
                ? 'border-bottom: solid 0.1em #C8F546; font-family:Seat-Bold;'
                : 'font-family:Seat-Regular'
            " (click)="changeMenu('landing2')" [routerLink]="['/landing-leasing']">
            {{ 'home' | i18next }}
          </button>
        </li>
        <li *ngIf="landing2 && user?.groupType !== collective.EXTERNVO">
          <button class="nav--menu__list--item" [style]="
              selectedItem === 'vehicles'
                ? 'border-bottom: solid 0.1em #C8F546; font-family:Seat-Bold;'
                : 'font-family:Seat-Regular'
            " (click)="changeMenu('vehicles')" [routerLink]="['/list-requests']">
            {{ 'landing2MyVehicles' | i18next }}
          </button>
        </li>
        <li *ngIf="landing2 && handlePermissions.getPermission('VO')" class="nav-item-with-submenu">
          <button class="nav--menu__list--item" [style]="
              selectedItem === 'vo'
                ? 'border-bottom: solid 0.1em #C8F546; font-family:Seat-Bold;'
                : 'font-family:Seat-Regular'
            " (click)="changeMenu('vo')" [routerLink]="['/vo']">
            {{ 'VOCars' | i18next }}
          </button>

          <div class="nav-submenu" *ngIf="user?.groupType !== collective.EXTERNVO">
            <button class="nav-submenu__item" (click)="changeMenu('vo')" [routerLink]="['/relatives-vo']">
              {{ 'relatives' | i18next }}
            </button>
            <!-- CRMSP-7485 - Empleados VO --> 
            <button *ngIf="handlePermissions.getPermission('COMPANY_ADMINVO')" class="nav-submenu__item"
              [routerLink]="['/extern-vo']">
              {{ 'externalVoAdmin' | i18next }}
            </button>
          </div>

          <div
            class="nav-submenu"
            *ngIf="
              user?.groupType === collective.EXTERNVO &&
              handlePermissions.getPermission('COMPANY_ADMINVO')
            "
          >
            <button class="nav-submenu__item" [routerLink]="['/extern-vo']">
              {{ 'externalVoAdmin' | i18next }}
            </button>
          </div>
        </li>

        <li *ngIf="!landing2">
          <button class="nav--menu__list--item" [style]="
              selectedItem === 'home'
                ? 'border-bottom: solid 0.1em #C8F546; font-family:Seat-Bold;'
                : 'font-family:Seat-Regular'
            " (click)="changeMenu('home')" [routerLink]="['/landing']">
            {{ 'home' | i18next }}
          </button>
        </li>
        <li *ngIf="!landing2">
          <button class="nav--menu__list--item" [style]="
              selectedItem === 'menu'
                ? 'border-bottom: solid 0.1em #C8F546; font-family:Seat-Bold;'
                : 'font-family:Seat-Regular'
            " (click)="changeMenu('menu')" [routerLink]="['/menu']">
            {{ 'requestMenuBtn' | i18next }}
          </button>
        </li>
        <li *ngIf="!landing2">
          <button class="nav--menu__list--item" [style]="
              selectedItem === 'vehicles'
                ? 'border-bottom: solid 0.1em #C8F546; font-family:Seat-Bold;'
                : 'font-family:Seat-Regular'
            " (click)="changeMenu('vehicles')" [routerLink]="['/list-requests']">
            {{ 'landingMyVehicles' | i18next }}
          </button>
        </li>
        <li *ngIf="
            !landing2 &&
            (user?.authorizer === 'CONTROLLER' ||
              user?.authorizer === 'DELEGATED_APPROVER' ||
              user?.category === 'MK' ||
              user?.category === 'AT' ||
              user?.category === 'OMK' ||
              user?.category === 'TMK' ||
              user?.category === 'PEC' ||
              user?.category === 'VICE' ||
              user?.category === 'PRESI' ||
              user?.category === 'PEC30' ||
              user?.category === 'ESP')
          ">
          <button class="nav--menu__list--item" [style]="
              selectedItem === 'authorizations'
                ? 'border-bottom: solid 0.1em #C8F546; font-family:Seat-Bold;'
                : 'font-family:Seat-Regular'
            " (click)="changeMenu('authorizations')" [routerLink]="['/authorizations']">
            {{ 'authTitle' | i18next }}
          </button>
        </li>
      </ul>
    </div>
    <div class="w-100 d-flex justify-content-end align-items-center">
      <div *ngIf="
          landing2 &&
          !onlyLandingLeasing() &&
          user?.groupType !== collective.EXTERNVO
        " class="w-100 d-flex justify-content-end">
        <div class="endowmentAndLease--container" [routerLink]="['/landing']">
          <mat-icon class="endowmentAndLease--container--icon">settings</mat-icon>
          <span class="endowmentAndLease--container--title text-uppercase text-truncate">{{ 'manageRequests' | i18next
            }}</span>
        </div>
      </div>
      <div *ngIf="!landing2 && canGoToLandingLeasing()" class="w-100 d-flex justify-content-end">
        <div class="endowmentAndLease--container" [routerLink]="['/landing-leasing']">
          <mat-icon class="endowmentAndLease--container--icon">settings</mat-icon>
          <span class="endowmentAndLease--container--title text-uppercase text-truncate">{{ 'endowmentAndLeasing' |
            i18next }}</span>
        </div>
      </div>
      <div class="nav--menu__list--support--container">
        <button class="nav--menu__list--support" (click)="openSupportModal()">
          {{ 'supportContact' | i18next }}
        </button>
      </div>
    </div>
    <div class="menu" ngbDropdown class="d-inline-block">
      <button type="button" class="btn btn-outline-primary panelBtn" id="dropdownBasic1" ngbDropdownToggle>
        <div class="panelBtn--title">
          <img src="../../../assets/icons/user.svg" alt="Icono usuario" />

          <p class="panelBtn--title__text" *ngIf="user">
            {{ user.fullName.split(' ')[0] | titlecase }}
          </p>
        </div>
      </button>
      <div ngbDropdownMenu class="dropdown" aria-labelledby="dropdownBasic1">
        <p>{{ user ? user.email : '-' }}</p>
        <p>nis: {{ user ? user.nis : '-' }}</p>
        <button class="dropdown--btn" ngbDropdownItem (click)="manageData()">
          {{ 'manageData' | i18next | uppercase }}
        </button>
        <hr />
        <button class="dropdown--btn" ngbDropdownItem (click)="onClickLogOut()">
          {{ 'logout' | i18next | uppercase }}
        </button>
      </div>
    </div>
  </div>
</main>